ACC.cartpopup = {
  minicartActive: '.ph-active-minicart',
  rolloverCart: '.rollover_cart_popup',
  rolloverVisible: '.rollover_cart_popup:visible',

  bindAll: function() {
    this.bindCartPop();
  },
  miniCartScrolling: function() {
    var itemsCountToShow = $(ACC.cartpopup.rolloverCart).find('.number-showing').val(),
        minicartListHeight = $(ACC.cartpopup.minicartActive).find('.ph-minicart_ul').height(),
        totalItems = 0,
        productRowItemsHeight = 0;

    $(ACC.cartpopup.minicartActive)
      .find('.ph-minicart__mainsection')
      .each(function() {
        if (totalItems < itemsCountToShow) {
          productRowItemsHeight =
            parseFloat(productRowItemsHeight) +
            parseFloat($(this).outerHeight(true));
        }

        totalItems = totalItems + 1;
      });

    $(ACC.cartpopup.minicartActive)
      .find('.ph-minicart_ul')
      .addClass('ph-cartpopup__scroll');

    if (minicartListHeight > productRowItemsHeight) {
      $(ACC.cartpopup.minicartActive)
        .find('.ph-cartpopup__scroll')
        .css('height', productRowItemsHeight + 4);
    }

    if (window.outerWidth < 960 && window.outerHeight < 992) {
      var mincartHeaderHeight = $(ACC.cartpopup.minicartActive).find('.ph-title:visible').outerHeight(true),
          mincartFooterHeight = $(ACC.cartpopup.minicartActive).find('.ph-minicart-footer:visible').outerHeight(true),
          topBarFixedHeight = 50,
          devoceToolbarHeight = 120,
          mincartHeight = window.outerHeight - devoceToolbarHeight,
          minicartContentHeight = parseFloat(mincartHeaderHeight) + parseFloat(mincartFooterHeight) + parseFloat(topBarFixedHeight),
          mobileMinicarScrollingArea = parseFloat(mincartHeight) - parseFloat(minicartContentHeight);

      $('.ph-headerparent__minicartparent')
        .find(ACC.cartpopup.minicartActive)
        .find('.ph-cartpopup__scroll')
        .css('height', mobileMinicarScrollingArea);

      if (window.outerHeight < 480) {
        var smallFooterHeight = window.outerHeight - 216;

        $('.ph-minicart-footer')
          .css('height', smallFooterHeight)
          .css('overflow-y', 'auto');
      }
    }

    $('.ph-headerparent__minicartparent')
      .find(ACC.cartpopup.minicartActive)
      .addClass('ph-minicart-flyin');

    $('.usabilla_live_button_container').addClass('ph-usabilla-feedback');
    setTimeout(function() {
      if ($(ACC.cartpopup.rolloverCart).is(':visible')) {
        $('html').addClass('ph-mincart-showing');
      }
    }, 600);
  },

  cartdata: function() {
    $.ajax({
      url: document.querySelector('.ph-rolloverPopupUrl').textContent,
      cache: false,
      type: 'GET',
      success: function(result) {
        $(ACC.cartpopup.rolloverCart).html(result);
        $(ACC.cartpopup.rolloverCart).show();
        ACC.imgLazyLoad.setImageObserver();

        var $productId = $('.prod_info a'),
            pid = '',
            $productid = '';

        $productId.each(function() {
          pid = $(this).attr('href');
          $productid =
            $productid +
            (';' + pid.substring(pid.lastIndexOf('/') + 1, pid.length) + ',');
        });

        ACC.cartpopup.miniCartScrolling();
        ACC.cartpopup.showPaymentPageMinicartAtp();
      }
    });
  },

  showPaymentPageMinicartAtp: function() {
    var $triggerAtpNode = $('.triggerAtpMinicart');

    if ($triggerAtpNode.length > 0 && $triggerAtpNode.text() === 'true') {
      if ($('.ph-anyoneoutofstock').val() === 'true') {
        $('.ph-minicart-someproduct__unavailable').show();
        $('.ph-minicart-product__unavailable').show();
      }
    }
  },

  popuphideOnMouseout: function() {
    setTimeout(function() {
      if (
        !$('.ph-headerparent__minicartdata').data('hover') &&
        !$(ACC.cartpopup.rolloverCart).data('hover')
      ) {
        $(ACC.cartpopup.rolloverCart).hide();
      }
    }, 100);
  },
  popuphide: function() {
    $(ACC.cartpopup.rolloverCart).hide();
    $(ACC.cartpopup.rolloverCart).removeClass('ph-active-minicart');
    $('.ph-minicart').removeClass('ph-minicart-flyin');
    $('html').removeClass('ph-mincart-showing');
  },
  bindCartPop: function() {
    ACC.cartpopup.popuphide();

    $('.ph-icon-shoppingcart').click(function(e) {
      e.preventDefault();
    });

    $('.ph-headerparent__minicartdata')
      .hover(function() {
        $.data(this, 'hover', true);
      },
      function() {
        $.data(this, 'hover', false);
      })
      .data('hover', false);

    $(ACC.cartpopup.rolloverCart)
      .hover(function() {
        $.data(this, 'hover', true);
      },
      function() {
        $.data(this, 'hover', false);
      })
      .data('hover', false);

    $('.ph-headerparent__minicartdata').on('click keypress', function(e) {
      if (e.type === 'click' || e.which === 13) {
        if ($(ACC.cartpopup.rolloverVisible).length === 1) {
          ACC.cartpopup.popuphide();
        } else {
          $(this)
            .parent()
            .parent()
            .find(ACC.cartpopup.rolloverCart)
            .addClass('ph-active-minicart');
          $('.ph-minicart').removeClass('ph-onestorecheckout_cartinfo');
          ACC.cartpopup.cartdata();
        }
      }
    });
    $('.ph-checkout_viewyourcart').on('click keypress', function() {
      if ($(ACC.cartpopup.rolloverVisible).length === 0) {
        $('.ph-headerparent__minicartdata').trigger('click');
        $('html, body').animate({
          scrollTop: 0
        }, 'slow');
      } else {
        ACC.cartpopup.popuphide();
      }
    });

    $(document).on('click', '.ph-minicart-close', function(e) {
      e.preventDefault();
      ACC.cartpopup.popuphide();
    });

    $('body,html').click(function(e) {
      if (
        $('.triggerAtpMinicart').length === 0 &&
        $(e.target).closest(ACC.cartpopup.rolloverCart).length === 0 &&
        $(e.target).closest('.ph-headerparent__minicartdata').length === 0 &&
        $(e.target).closest('.ph-checkout_viewyourcart').length === 0
      ) {
        ACC.cartpopup.popuphide();
      }

      if ($(e.target).closest('.ph-position-tooltip').length === 0) {
        $('.ph-loggedin-tooltip').addClass('ph-hidden');
      }

      if ($(e.target).closest('.ph-language_ddown,.ph-langOptionIcon').length === 0) {
        $(document).find('.ph-language_ddown').hide();
      }
    });
  }
};

$(document).on('click', '.ph-checkoutbutton__done', function(e) {
  e.preventDefault();
  ACC.cartpopup.popuphide();
});

$(document).ready(function() {
  ACC.cartpopup.bindAll();
});

$(window).resize(function() {
  ACC.cartpopup.miniCartScrolling();
});
